import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Province = () => {
  const { t, errors, province, showProvince, customInput, updateAddress, isEditable } = useAddress()

  if (!showProvince) {
    return null
  }

  return (
    <SDFormControl plainLabel error={getError('province', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.readonly_province')}
        currentValue={province}
        readOnly={!customInput}
        disabled={!customInput || isEditable === false}
        onBlur={customInput ? value => updateAddress({ province: value }) : undefined}
        overrides={undefined}
        status={undefined}
        outerOnchange={undefined}
      />
    </SDFormControl>
  )
}

export default Province
